<template>
    <div class="card card-with-shadow border-0 h-100 employee-preview-card">
        <div class="card-body position-relative d-flex flex-column justify-content-between">
            <div v-if="showAction" class="dropdown options-dropdown position-absolute">
                <button type="button"
                        class="btn-option btn d-flex align-items-center justify-content-center"
                        data-toggle="dropdown">
                    <app-icon name="more-horizontal"/>
                </button>
                <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                    <a class="dropdown-item px-4 py-2"
                       href="#"
                       v-for="(action,index) in actions"
                       :key="index"
                       v-if="checkIfVisible(action, employee)"
                       @click.prevent="callAction(action)">
                        {{ action.title }}
                    </a>
                </div>
            </div>
            <div class="text-center">
                <app-avatar
                    :title="employee.name_romaji"
                    avatar-class="avatars-w-50 mb-2 mx-auto d-inline-block"
                    :img="getImageUrl(employee)"
                />
                <p class="mb-2">{{ employee.name_romaji }}</p>
                <p class="mb-2">{{ employee.name_katakana }}</p>
                <p class="mb-2 font-size-80 text-muted">{{ employee.email }}</p>
                <p class="mb-2 font-size-80 text-muted">{{ employee.phone }}</p>
                <p class="mb-2 font-size-80 text-muted">{{ employee.recruitment_text }}</p>
                <div class="my-3">
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="badge badge-pill badge-warning text-capitalize">
                            {{employee.residence_text}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name   : "CandidatePreviewCard",
    extends: CoreLibrary,
    props  : {
        employee  : {
            type    : Object,
            required: true
        },
        actions   : {
            type   : Array,
            require: true
        },
        showAction: {
            type   : Boolean,
            default: true
        },
        id        : {
            type   : String,
            require: true
        }
    },
    methods: {
        callAction(action) {
            this.$emit('action-' + this.id, this.employee, action, true)
        },
        checkIfVisible(action, employee) {
            if (this.isFunction(action.modifier)) {
                return action.modifier(employee);
            }
            return true;
        },
        getImageUrl(employee) {
            if (employee.avatar) {
                return urlGenerator(employee.avatar);
            }
        }
    },
}
</script>
